import { useQuery } from 'data-fetching-client';
import UILink from 'UIComponents/link/UILink';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import { adAudiencesUrl } from 'automation-ui-references/routing/hubspotUrls';
import { GET_WORKFLOW_AUDIENCES } from 'automation-ui-action-features/actions/ads-audience-membership/adsAudienceResourceQueries';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AdsAudienceLink({
  id
}) {
  const {
    data: {
      workflowAudiences = []
    } = {},
    loading
  } = useQuery(GET_WORKFLOW_AUDIENCES, {
    skip: !id
  });
  const workflowAudience = workflowAudiences.find(audience => audience.targetingAudience.id === id);
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  } else if (workflowAudience) {
    return /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: adAudiencesUrl(workflowAudience.targetingAudience.id),
      onClick: event => event.stopPropagation(),
      children: workflowAudience.networkState.name
    });
  } else {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "adsAudience"
    });
  }
}